export const tableColumns = () => {
  return [
    {
      field: 'projectCode',
      title: '项目编号',
      width: '200',
      className: 'link-color',
    },
    {
      field: 'projectName',
      title: '项目名称',
      width: '280',
    },
    {
      field: 'effectiveDate',
      title: '生效日期',
      width: '200',
    },
  ];
};
